import DisplayFilesByLeadFile from './DisplayFilesByLeadFile.component';

export default DisplayFilesByLeadFile;
